import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PRODUCTTEMPLATEAPI from "../../Api/ProductTemplate";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";



export const fetchProductTemplates = createAsyncThunk("template/fetchProductTemplates", async (params, thunkAPI) => {
    try {
        const response = await PRODUCTTEMPLATEAPI.getProductTemplates(params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const fetchProductTemplatesById = createAsyncThunk("template/fetchProductTemplates", async (id, thunkAPI) => {
    try {
        const response = await PRODUCTTEMPLATEAPI.getProductTemplatesById(id);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const addProductTemplate = createAsyncThunk("template/addTemplate", async (formData, thunkAPI) => {
    try {
        const response = await PRODUCTTEMPLATEAPI.addProductTemplate(formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const updateProductTemplate = createAsyncThunk("template/updateTemplate", async ({ id, formData }, thunkAPI) => {
    try {
        const response = await PRODUCTTEMPLATEAPI.updateProductTemplate(id, formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const deleteProductTemplate = createAsyncThunk("template/deleteTemplate", async (id, thunkAPI) => {
    try {
        const response = await PRODUCTTEMPLATEAPI.deleteProductTemplate(id);
        return id;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

const ProductTemplateReducer = createSlice({
    name: "Producttemplate",
    initialState: {
        Producttemplates:[],
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductTemplates.fulfilled, (state, action) => {
                state.Producttemplates = action.payload.data;
            })
            .addCase(addProductTemplate.fulfilled, (state, action) => {
                state.Producttemplates.push(action.payload.data);
            })
            .addCase(updateProductTemplate.fulfilled, (state, action) => {
                const {
                    arg: { id },
                } = action.meta;
                console.log(action.payload)
                if (id) {
                    state.Producttemplates = state.Producttemplates.map((template) =>
                        template._id === id ? action.payload.data : template
                    );
                }
            })
            .addCase(deleteProductTemplate.fulfilled, (state, action) => {
                state.Producttemplates = state.Producttemplates.filter((template) => template.id !== action.payload);
            })
            .addCase(fetchProductTemplates.rejected, (state, action) => {
                state.Producttemplates=[]
                state.error = action.payload;
            })
            .addCase(addProductTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateProductTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(deleteProductTemplate.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

const { reducer } = ProductTemplateReducer;
export default reducer;
